import React, { useState, useEffect } from "react"
import axios from 'axios';
import {
    Col,
    Form,
    FormGroup,
    Input,
    Row,
    Button,
    FormFeedback,
    InputGroup
} from "reactstrap"

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import PropTypes from 'prop-types';
import Flatpickr from "react-flatpickr";
import { fdDetailsUrl, getFDDetailsUrl } from "../../helpers/fakebackend_helper";
import authHeader from "helpers/authHeader";

const FD = ({ RegistrationId }) => {

    const formBackground = {
        borderRadius: 8,
        flex: 1,
        ////backgroundColor: "rgb(247 242 242)",
        padding: "15px"
    }

    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }

    const label = {
        color: "black"
    }

    const formMandatory = {
        color: "red",
        fontWeight: "bold"
    }

    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    $(".d-block").flatpickr({
        dateFormat: "d-M-Y",
        altFormat: "F j, Y",
        maxDate: "today",
        disableMobile: "true"
    });

    const [branch, setBranch] = useState([]);
    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    function autorenewalValidation(value) {
        debugger;
        validation.values.periodyear = "";
        validation.values.periodmonth = "";
        validation.values.perioddays = "";

        const autorenewal = value.target.value;

        if (autorenewal != '') {
            if ($("#rbautorenewalyes").prop("checked")) {
                $("#txtperiodyear").prop('disabled', false);
                $("#txtperiodmonth").prop('disabled', false);
                $("#txtperioddays").prop('disabled', false);
            }
            else if ($("#rbautorenewalno").prop("checked")) {
                $("#txtperiodyear").prop('disabled', true);
                $("#txtperiodmonth").prop('disabled', true);
                $("#txtperioddays").prop('disabled', true);
            }
        }
    }

    const [fdData, setFDData] = useState([]);

    // Form validation
    const validation = useFormik({

        enableReinitialize: true,

        initialValues: {

            depositamount: fdData.depositAmount == null ? '' : fdData.depositAmount,
            tenureyear: fdData.tenureYear == null ? '' : fdData.tenureYear,
            tenuremonth: fdData.tenureMonths == null ? '' : fdData.tenureMonths,
            tenuredays: fdData.tenureDays == null ? '' : fdData.tenureDays,
            bankname: fdData.bankName == null ? '' : fdData.bankName,
            branchname: fdData.branchName == null ? '' : fdData.branchName,
            accountnumber: fdData.accountNo == null ? '' : fdData.accountNo,
            ifsc: fdData.ifsc == null ? '' : fdData.ifsc,
            periodyear: fdData.periodYear == null ? '' : $("#rbautorenewalno").prop("checked") ? '' : fdData.periodYear,
            periodmonth: fdData.periodMonths == null ? '' : $("#rbautorenewalno").prop("checked") ? '' : fdData.periodMonths,
            perioddays: fdData.periodDays == null ? '' : $("#rbautorenewalno").prop("checked") ? '' : fdData.periodDays,
            tdsmembershipno: fdData.tdsMembershipNo == null ? '' : fdData.tdsMembershipNo
        },
        validationSchema: Yup.object({
            depositamount: Yup.string().required("Deposit Amount required"),
            tenureyear: Yup.string().required("Years required"),
            tenuremonth: Yup.string().required("Months required"),
            tenuredays: Yup.string().required("Days required"),
            bankname: Yup.string().required("Bank Name required").matches(/^[A-Za-z ]+$/, "Enter character only!"),
            branchname: Yup.string().required("Branch Name required"),
            accountnumber: Yup.string().required("Account Number required"),
            ifsc: Yup.string().required("IFSC required"),
        }),
        onSubmit: (values) => {
            //console.log("values", values);
        }
    });

    function CheckIsValid(controlValues) {
        var x = Object.keys(controlValues[0])
        var isCheckIfUndefined = x.map(p => {
            if (controlValues[0][p] === "" || controlValues[0][p] === undefined) {
                return true
            }
            else
                return false
        })

        var checkResponse = isCheckIfUndefined.includes(true)
        return checkResponse
    }

    const fdDetails = {
        RegistrationId: '',
        DepositAmount: '',
        TenureYear: '',
        TenureMonths: '',
        TenureDays: '',
        InterestPayout: '',
        InterestPayoutMode: '',
        BankName: '',
        BranchName: '',
        AccountNo: '',
        IFSC: '',
        IsAutoRenewal: '',
        PeriodYear: '',
        PeriodMonths: '',
        PeriodDays: '',
        TDSMembershipNo: ''
    }

    function chkNumeric(e) {
        let input = e.target.value;

        if (input == "") {
            validation.handleChange(e);
        }
        else if (typeof input !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (pattern.test(input)) {
                validation.handleChange(e);
            }
        }
    }

    useEffect(() => {
        GetFDDetails();
    }, []);

    function BindFDDetails(fdDeails) {
        if (fdDeails.interestPayout != null) {
            if (fdDeails.interestPayout == "Monthly") {
                $('#rbmonthly').prop('checked', true);
            }
            else if (fdDeails.interestPayout == "Quarterly") {
                $('#rbquarterly').prop('checked', true);
            }
            else if (fdDeails.interestPayout == "Half Yearly") {
                $('#rbhalfyearly').prop('checked', true);
            }
            else if (fdDeails.interestPayout == "Yearly") {
                $('#rbyearly').prop('checked', true);
            }
        }

        if (fdDeails.interestPayoutMode != null) {
            if (fdDeails.interestPayoutMode == "Standing Instructions") {
                $('#rbstandinginstructions').prop('checked', true);
            }
            else if (fdDeails.interestPayoutMode == "ECS") {
                $('#rbecs').prop('checked', true);
            }
            else if (fdDeails.interestPayoutMode == "Pay Order") {
                $('#rbpayorder').prop('checked', true);
            }
        }

        if (fdDeails.isAutoRenewal != null) {
            if (fdDeails.isAutoRenewal == true) {
                $('#rbautorenewalyes').prop('checked', true);
            }
            else if (fdDeails.isAutoRenewal == false) {
                $('#rbautorenewalno').prop('checked', true);
            }
        }
    }

    function GetFDDetails() {
        const customerDetailModel = {
            RegistrationId: RegistrationId
        };

        axios.post(getFDDetailsUrl(), customerDetailModel, { headers: authHeader() })
            .then(response => {
                debugger;
                if (response.data.length > 0) {
                    BindFDDetails(response.data[0]);
                    setFDData(response.data[0]);

                    if ($("#rbautorenewalyes").prop("checked")) {
                        $("#txtperiodyear").prop('disabled', false);
                        $("#txtperiodmonth").prop('disabled', false);
                        $("#txtperioddays").prop('disabled', false);
                    }
                    else if ($("#rbautorenewalno").prop("checked")) {
                        $("#txtperiodyear").prop('disabled', true);
                        $("#txtperiodmonth").prop('disabled', true);
                        $("#txtperioddays").prop('disabled', true);
                    }
                }
            }, (error) => {
                console.log(error.response);
            })
    }

    function SaveFDDetails(RegistrationId) {

        if ($("#rbautorenewalyes").prop("checked")) {
            if ($('#txtperiodyear').val().trim() == "") {
                ErrorMessage("Please enter Period Year");
                $('#txtperiodyear').focus();
                return;
            }
            else if ($('#txtperiodmonth').val().trim() == "") {
                ErrorMessage("Please enter Period Month");
                $('#txtperiodmonth').focus();
                return;
            }
            else if ($('#txtperioddays').val().trim() == "") {
                ErrorMessage("Please enter Period Days");
                $('#txtperioddays').focus();
                return;
            }
        }

        fdDetails.RegistrationId = RegistrationId;

        fdDetails.DepositAmount = $('#txtdepositamount').val().trim();
        fdDetails.TenureYear = $('#txttenureyear').val().trim();
        fdDetails.TenureMonths = $('#txttenuremonth').val().trim();
        fdDetails.TenureDays = $('#txttenuredays').val().trim();
        if ($("#rbmonthly").prop("checked")) {
            fdDetails.InterestPayout = "Monthly";
        }
        else if ($("#rbquarterly").prop("checked")) {
            fdDetails.InterestPayout = "Quarterly";
        }
        else if ($("#rbhalfyearly").prop("checked")) {
            fdDetails.InterestPayout = "Half Yearly";
        }
        else if ($("#rbyearly").prop("checked")) {
            fdDetails.InterestPayout = "Yearly";
        }
        else if ($("#rbonmaturity").prop("checked")) {
            fdDetails.InterestPayout = "On Maturity";
        }

        if ($("#rbstandinginstructions").prop("checked")) {
            fdDetails.InterestPayoutMode = "Standing Instructions";
        }
        else if ($("#rbecs").prop("checked")) {
            fdDetails.InterestPayoutMode = "ECS";
        }
        else if ($("#rbpayorder").prop("checked")) {
            fdDetails.InterestPayoutMode = "Pay Order";
        }

        fdDetails.BankName = $('#txtbankname').val().trim();
        fdDetails.BranchName = $('#txtbranchname').val().trim();
        fdDetails.AccountNo = $('#txtaccountnumber').val().trim();
        fdDetails.IFSC = $('#txtifsc').val().trim();

        if ($("#rbautorenewalyes").prop("checked")) {
            fdDetails.IsAutoRenewal = "true";
        }
        else if ($("#rbautorenewalno").prop("checked")) {
            fdDetails.IsAutoRenewal = "false";
        }

        if ($("#rbautorenewalyes").prop("checked")) {
            fdDetails.PeriodYear = $('#txtperiodyear').val().trim();
            fdDetails.PeriodMonths = $('#txtperiodmonth').val().trim();
            fdDetails.PeriodDays = $('#txtperioddays').val().trim();
        }
        else {
            fdDetails.PeriodYear = "";
            fdDetails.PeriodMonths = "";
            fdDetails.PeriodDays = "";
        }
        fdDetails.TDSMembershipNo = $('#txttdsmembershipno').val().trim();

        axios.post(fdDetailsUrl(), fdDetails, { headers: authHeader() })
            .then(res => {
                if (res.data.responseCode == "OK") {
                    SuccessMessage(res.data.responseMessage);
                }
                else {
                    ErrorMessage(res.data.responseMessage);
                }
            })
    }

    return (
        <React.Fragment>
            <Row style={{ backgroundColor: "white" }}>
                <Col >
                    <div className="table-responsive">
                        <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Deposit Amount</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="depositamount"
                                            placeholder="Deposit Amount"
                                            type="text"
                                            className="form-control"
                                            id="txtdepositamount"
                                            maxLength="10"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.depositamount || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.depositamount &&
                                                    (validation.touched &&
                                                        validation.touched.depositamount) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.depositamount &&
                                                (validation.touched &&
                                                    validation.touched.depositamount) ? (
                                                <FormFeedback type="invalid">{validation.errors.depositamount}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Tenure Year</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="tenureyear"
                                            placeholder="Years"
                                            type="text"
                                            className="form-control"
                                            id="txttenureyear"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tenureyear || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.tenureyear &&
                                                    (validation.touched &&
                                                        validation.touched.tenureyear) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.tenureyear &&
                                                (validation.touched &&
                                                    validation.touched.tenureyear) ? (
                                                <FormFeedback type="invalid">{validation.errors.tenureyear}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Tenure Month</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="tenuremonth"
                                            placeholder="Months"
                                            type="text"
                                            className="form-control"
                                            id="txttenuremonth"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tenuremonth || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.tenuremonth &&
                                                    (validation.touched &&
                                                        validation.touched.tenuremonth) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.tenuremonth &&
                                                (validation.touched &&
                                                    validation.touched.tenuremonth) ? (
                                                <FormFeedback type="invalid">{validation.errors.tenuremonth}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Tenure Days</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="tenuredays"
                                            placeholder="Days"
                                            type="text"
                                            className="form-control"
                                            id="txttenuredays"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tenuredays || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.tenuredays &&
                                                    (validation.touched &&
                                                        validation.touched.tenuredays) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.tenuredays &&
                                                (validation.touched &&
                                                    validation.touched.tenuredays) ? (
                                                <FormFeedback type="invalid">{validation.errors.tenuredays}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <label style={label}>Interest Payout</label>
                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbmonthly"
                                            value="option1"
                                            defaultChecked
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Monthly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbquarterly"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Quarterly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3" style={{ width: "110%" }}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbhalfyearly"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Half Yearly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbyearly"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Yearly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="2">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbonmaturity"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            On Maturity
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <label style={label}>Mode of Interest</label>
                                <Col lg="2">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestmode"
                                            id="rbstandinginstructions"
                                            value="option1"
                                            defaultChecked
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Standing Instructions
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestmode"
                                            id="rbecs"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            ECS
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="2">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestmode"
                                            id="rbpayorder"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Pay Order
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Details of bank account in which interest payout/amount payable on maturity desired to be deposited</label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Bank Name</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="bankname"
                                            placeholder="Bank Name"
                                            type="text"
                                            className="form-control"
                                            id="txtbankname"
                                            maxLength="100"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.bankname || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.bankname &&
                                                    (validation.touched &&
                                                        validation.touched.bankname) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.bankname &&
                                                (validation.touched &&
                                                    validation.touched.bankname) ? (
                                                <FormFeedback type="invalid">{validation.errors.bankname}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Branch Name</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="branchname"
                                            placeholder="Branch Name"
                                            type="text"
                                            className="form-control"
                                            id="txtbranchname"
                                            maxLength="100"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.branchname || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.branchname &&
                                                    (validation.touched &&
                                                        validation.touched.branchname) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.branchname &&
                                                (validation.touched &&
                                                    validation.touched.branchname) ? (
                                                <FormFeedback type="invalid">{validation.errors.branchname}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Account Number</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="accountnumber"
                                            placeholder="Account Number"
                                            type="text"
                                            className="form-control"
                                            id="txtaccountnumber"
                                            maxLength="20"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.accountnumber || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.accountnumber &&
                                                    (validation.touched &&
                                                        validation.touched.accountnumber) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.accountnumber &&
                                                (validation.touched &&
                                                    validation.touched.accountnumber) ? (
                                                <FormFeedback type="invalid">{validation.errors.accountnumber}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>IFSC</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="ifsc"
                                            placeholder="IFSC"
                                            type="text"
                                            className="form-control"
                                            id="txtifsc"
                                            maxLength="20"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.ifsc || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.ifsc &&
                                                    (validation.touched &&
                                                        validation.touched.ifsc) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.ifsc &&
                                                (validation.touched &&
                                                    validation.touched.ifsc) ? (
                                                <FormFeedback type="invalid">{validation.errors.ifsc}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>
                                <Col lg="2">
                                    <label style={label}>Auto renewal</label>
                                    <Col lg="3" style={{ display: "flex", marginTop: "10px" }}>
                                        <div className="form-check mb-3">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="autorenewal"
                                                id="rbautorenewalyes"
                                                value="option1"
                                                onClick={e => { autorenewalValidation(e); validation.handleChange(e) }}
                                                defaultChecked
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="exampleRadios1"
                                            >
                                                Yes
                                            </label>
                                        </div>

                                        <div className="form-check mb-3" style={{ marginLeft: "10px" }}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="autorenewal"
                                                id="rbautorenewalno"
                                                value="option1"
                                                onClick={e => { autorenewalValidation(e); validation.handleChange(e) }}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="exampleRadios1"
                                            >
                                                No
                                            </label>
                                        </div>
                                    </Col>
                                </Col>
                                <Col lg="2">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Period Year</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="periodyear"
                                            placeholder="Years"
                                            type="text"
                                            className="form-control"
                                            id="txtperiodyear"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.periodyear || ""}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Period Month</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="periodmonth"
                                            placeholder="Months"
                                            type="text"
                                            className="form-control"
                                            id="txtperiodmonth"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.periodmonth || ""}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Period Days</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="perioddays"
                                            placeholder="Days"
                                            type="text"
                                            className="form-control"
                                            id="txtperioddays"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.perioddays || ""}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Col lg="4">
                                        <label style={label}>About TDS: Deduct 15G/15H/Membership Number</label>
                                    </Col>
                                    <Col lg="3">
                                        <Input
                                            name="tdsmembershipno"
                                            placeholder="Membership Number"
                                            type="text"
                                            className="form-control"
                                            id="txttdsmembershipno"
                                            maxLength="20"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tdsmembershipno || ""}
                                            autoComplete="off"
                                        />
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="1">

                                </Col>
                                <Col lg="10">
                                </Col>
                                <Col lg="1">
                                    <Button id="firstN" style={formButton} type="submit"
                                        onClick={() => {
                                            let isEmpty = CheckIsValid([{
                                                depositamount: validation.values.depositamount,
                                                tenureyear: validation.values.tenureyear,
                                                tenuremonth: validation.values.tenuremonth,
                                                tenuredays: validation.values.tenuredays,
                                                bankname: validation.errors.bankname == undefined ? validation.values.bankname : "",
                                                branchname: validation.values.branchname,
                                                accountnumber: validation.values.accountnumber,
                                                ifsc: validation.values.ifsc
                                            }])
                                            if (!isEmpty)
                                                SaveFDDetails(RegistrationId);
                                        }} >
                                        Save
                                    </Button>
                                </Col>
                            </Row>

                            <Row>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
};

FD.propTypes = {
    RegistrationId: PropTypes.string
}

export default FD
